var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 466,
    viewBox: "0 0 750 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilus-1",
    clipPath: "url(#clip0_386_375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.4 16.4399H661.35V420.86H89.62L89.4 16.4399Z",
    stroke: "#F3CAD2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M645.81 38.0601V253.78H104.93V38.0601H645.81ZM646.81 37.0601H103.93V254.78H646.81V37.0601Z",
    fill: "#F9E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M463.74 265.21H287.34V369.54H463.74V265.21Z",
    stroke: "#F9E6E9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M280.16 265.21H103.76V369.54H280.16V265.21Z",
    stroke: "#F9E6E9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M647.32 265.21H470.92V369.54H647.32V265.21Z",
    stroke: "#F9E6E9",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M87.37 0.04L662.7 0C675.88 0 686.57 10.69 686.57 23.87V24.32V431.44H64.18V23.19C64.18 10.39 74.57 0.02 87.37 0.04Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 431.44H749.62C749.62 450.09 734.09 465.22 714.94 465.22H34.68C15.53 465.22 0 450.1 0 431.44Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M303.09 431.44H447.65L437.07 441.8H314.12L303.09 431.44Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M89.4 16.4399H661.35V420.86H89.62L89.4 16.4399Z",
    fill: "#CFC5D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M280.16 265.21H103.76V369.54H280.16V265.21Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M463.74 265.21H287.34V369.54H463.74V265.21Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M647.32 265.21H470.92V369.54H647.32V265.21Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M645.81 38.0601H104.93V253.78H645.81V38.0601Z",
    fill: "#E8E4EC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M342.72 400.36C347.442 400.36 351.27 396.532 351.27 391.81C351.27 387.088 347.442 383.26 342.72 383.26C337.998 383.26 334.17 387.088 334.17 391.81C334.17 396.532 337.998 400.36 342.72 400.36Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M375.37 400.36C380.092 400.36 383.92 396.532 383.92 391.81C383.92 387.088 380.092 383.26 375.37 383.26C370.648 383.26 366.82 387.088 366.82 391.81C366.82 396.532 370.648 400.36 375.37 400.36Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M408.02 400.36C412.742 400.36 416.57 396.532 416.57 391.81C416.57 387.088 412.742 383.26 408.02 383.26C403.298 383.26 399.47 387.088 399.47 391.81C399.47 396.532 403.298 400.36 408.02 400.36Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M619.01 54.04H529.85C526.117 54.04 523.09 57.0644 523.09 60.795C523.09 64.5257 526.117 67.55 529.85 67.55H619.01C622.743 67.55 625.77 64.5257 625.77 60.795C625.77 57.0644 622.743 54.04 619.01 54.04Z",
    fill: "#EEA9B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M267.96 271.11H238.46C236.472 271.11 234.86 272.722 234.86 274.71V274.72C234.86 276.708 236.472 278.32 238.46 278.32H267.96C269.948 278.32 271.56 276.708 271.56 274.72V274.71C271.56 272.722 269.948 271.11 267.96 271.11Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M541.55 340.1L547.09 369.24L570.6 369.54L575.23 337.58L566.55 351.67L559.34 343.2L550.56 352.43L541.55 340.1Z",
    fill: "#EEA9B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M543.8 331.65L559.11 342.94L550.33 352.17L540.52 337.87C540.52 337.87 542.87 334.8 543.8 331.64V331.65Z",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M559.12 342.95L566.32 351.42L574.65 337.65L570.83 331.65L559.12 342.95Z",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01_bottomRightFace"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M580.49 300.47C580.49 300.47 581.81 293.49 582.6 287.58C583.14 283.52 580.16 281.96 578.24 281.39C577.4 281.14 576.74 280.45 576.65 279.58C575.66 270.06 564.04 270.15 564.04 270.15C549.07 268.85 544.17 276.39 543.02 278.76C542.79 279.23 542.4 279.58 541.93 279.8C531.1 284.87 537.86 300.37 537.86 300.37L540.45 300.48L542.72 301.17L554.41 301.81L574.24 301.34L576.91 300.59L580.5 300.48L580.49 300.47Z",
    fill: "#8F72AC",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M543.54 287.66C546.93 289.73 559.87 296.43 574.91 288.68C575.29 288.48 575.75 288.75 575.73 289.19L574.64 315.47C574.64 315.47 572.42 327.86 558.43 327.41C544.44 326.96 542.89 314.34 542.89 314.34L542.67 288.14C542.67 287.7 543.15 287.42 543.53 287.66H543.54Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M542.22 300.98C542.22 300.98 536.07 298.31 534.8 304.07C533.59 309.54 535.87 315.18 543.42 316.52",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M575.63 300.98C575.63 300.98 581.78 298.31 583.05 304.07C584.26 309.54 581.98 315.18 574.43 316.52",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M558.1 301.57C558.1 301.57 562.72 308.91 562.13 312.86C562.13 312.86 561.62 314.29 556.19 311.35",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M546.51 322.68L545.61 332.98L558.36 342.38L570.38 332.08L569.64 323.9C569.64 323.9 567.37 327.84 558.45 327.41C549.53 326.98 546.51 322.68 546.51 322.68V322.68Z",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M541.55 340.1L502.47 357.51L500.21 369.55L547.41 369.24L541.55 340.1Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M574.82 340.45L609.78 353.71L617.89 369.57L570.38 369.29L574.82 340.45Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01_bottomLeftFace"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.65 300.93C167.65 300.93 161.51 287.37 172.34 282.3C172.81 282.08 173.2 281.73 173.43 281.26C174.59 278.89 178.62 266.49 193.59 267.79C193.59 267.79 212 269.57 209.31 282C209.12 282.86 210.06 283.56 210.9 283.81C212.82 284.38 214.86 285.99 214.32 290.05C213.53 295.96 212.27 301.06 212.27 301.06",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65 300.93C167.65 300.93 161.51 287.37 172.34 282.3C172.81 282.08 173.2 281.73 173.43 281.26C174.59 278.89 178.62 266.49 193.59 267.79C193.59 267.79 212 269.57 209.31 282C209.12 282.86 210.06 283.56 210.9 283.81C212.82 284.38 214.86 285.99 214.32 290.05C213.53 295.96 212.27 301.06 212.27 301.06",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M177.38 325.26L174.41 345.56C174.41 345.56 190.46 353.41 202.89 345.75L201.46 326.56C201.46 326.56 200.5 330.04 189.6 329.94C178.7 329.84 177.37 325.27 177.37 325.27L177.38 325.26Z",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M173.14 287.1C176.89 289.33 191.18 296.55 207.79 288.2C208.21 287.99 208.72 288.28 208.7 288.74L207.5 317.06C207.5 317.06 205.05 330.42 189.6 329.93C174.15 329.44 172.43 315.85 172.43 315.85L172.19 287.62C172.19 287.14 172.72 286.85 173.14 287.1Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M171.36 301.59C171.36 301.59 164.9 298.77 163.56 304.84C162.29 310.61 164.69 316.56 172.62 317.98",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M208.39 301.57C208.39 301.57 214.02 298.81 215.18 304.75C216.28 310.39 214.2 316.21 207.29 317.6",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M189.9 302.64C189.9 302.64 194.69 310.95 194.05 315.12C194.05 315.12 193.5 316.64 187.58 313.52",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M173.84 344.97H169.56L131.28 361.64L127.9 369.55H174.06L173.84 344.97Z",
    fill: "#E88199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M203.11 344.97H207.39L245.67 361.64L249.05 369.55H202.89L203.11 344.97Z",
    fill: "#E88199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M173.84 344.97L174.07 369.55H202.89L203.12 344.97C203.12 344.97 197.63 349.11 188.48 348.27C178.45 347.35 173.84 344.97 173.84 344.97Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01_topFace"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M304.61 117.2C304.61 117.2 297.58 49.6099 355.64 50.0399C355.64 50.0399 401.76 54.0399 397.74 116.6L304.6 117.2H304.61Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.31 116.19C389.31 116.19 405.23 114.82 405.23 129.25C405.23 143.18 398 151.99 388.37 154.02",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31 116.19C389.31 116.19 405.23 114.82 405.23 129.25C405.23 143.18 398 151.99 388.37 154.02",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.1 117.02C312.1 117.02 296.57 113.43 293.99 127.22C291.4 141.02 304.81 155 312.12 154.69",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1 117.02C312.1 117.02 296.57 113.43 293.99 127.22C291.4 141.02 304.81 155 312.12 154.69",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M312.83 89.3298L311.05 140.11C310.65 151.46 314.54 162.7 322.44 170.86C328.17 176.77 336.41 180.42 348.59 181.55C348.59 181.55 384.81 181.61 388.94 148.16L389.27 91.0598C389.28 89.2698 387.3 88.1698 385.8 89.1598C381.1 92.2598 371.01 98.7898 351.65 98.0498C331.62 97.2798 321.04 90.4298 316.25 87.4998C314.77 86.5898 312.87 87.5898 312.81 89.3298H312.83Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M352.24 123.13C352.24 123.13 359.41 140.45 357.54 147.64L345.87 147.27",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M323.45 173.08L318.41 208.72L320.26 209.41C337.92 215.98 357.23 215.7 375.33 210.45L376.28 211.18L374.87 173.09C374.87 173.09 365.43 181.71 348.61 181.57C331.79 181.43 323.46 173.09 323.46 173.09L323.45 173.08Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M225.63 254.45L231.71 240.71C231.71 240.71 253.13 227.45 308.72 207.16L318.4 206.71L318.17 253.77L225.62 254.45H225.63Z",
    fill: "#E24473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M468.26 254.45L462.18 240.71C462.18 240.71 440.76 229.45 385.17 209.16L380.81 208.96L375.49 208.71L375.72 253.77L468.27 254.45H468.26Z",
    fill: "#E24473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M317.59 206.71L317.36 253.77H376.27L376.85 208.52C376.85 208.52 352.8 218.5 317.59 206.71Z",
    fill: "#EEA9B8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "01_topHand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.09 220.63C523.09 220.63 530.28 213.25 531 202.43C531 202.43 525.11 179.11 532.44 173.65C532.44 173.65 538.48 170.49 540.35 188.31L582.63 156.7C583.3 156.2 584.21 156.08 584.95 156.47C586.55 157.31 588.66 159.41 585.72 164.16L566.51 178.82C566.51 178.82 579.01 190.32 572.98 203.97C572.98 203.97 568.9 210.83 565.12 213.73C561.34 216.62 552.4 239.02 552.4 239.02",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.09 220.63C523.09 220.63 530.28 213.25 531 202.43C531 202.43 525.11 179.11 532.44 173.65C532.44 173.65 538.48 170.49 540.35 188.31L582.63 156.7C583.3 156.2 584.21 156.08 584.95 156.47C586.55 157.31 588.66 159.41 585.72 164.16L566.51 178.82C566.51 178.82 579.01 190.32 572.98 203.97C572.98 203.97 568.9 210.83 565.12 213.73C561.34 216.62 552.4 239.02 552.4 239.02",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M500.12 254.9L522.64 217.52L555.96 241.62L550.79 254.9H500.12Z",
    fill: "#E24473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M550.11 206.71C550.11 206.71 554.91 194.28 542.59 186.62",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M359.38 336.77C359.38 336.77 351.92 334.98 349.7 340.53C346.94 347.43 354 369 354 369H387C387 369 392.77 347.43 390 340.53C387.78 334.98 380.32 336.77 380.32 336.77H359.38Z",
    fill: "#B2A1C4",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M389.82 339.91L416.35 350.68C416.35 350.68 423.02 353.64 424.42 369.35L386.54 369.56L385.48 368.55C385.48 368.55 392.45 347.83 389.82 339.91Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M349.62 339.91L323.09 350.68C323.09 350.68 316.42 354.14 315.02 369.85L352.4 369.56H353.96C353.96 369.56 346.99 347.83 349.62 339.91Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.16 323C359.16 323 358.21 369.18 369.74 368.74C371.95 368.66 373.1 369.32 374.47 367.17C380.24 358.13 380.03 332.5 380.1 325.06",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.16 323C359.16 323 358.21 369.18 369.74 368.74C371.95 368.66 373.1 369.32 374.47 367.17C380.24 358.13 380.03 332.5 380.1 325.06",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "01_bottomCenterFace"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M340.26 302.74L337.78 306.7L335.96 312.79L336.48 319.02L335.25 324.41L332.89 326.99L328.79 327.55L320.43 323.96L321.99 328.89L324.85 332.61L329.36 335.37L334.49 336.53H342.18L351.39 332.86L357.25 326.9L358.32 323.04L354.23 317.38L353.59 315.26L349.08 314.52L344.78 309.81L343.91 305.34L344.6 301.53L347.11 299.4L351.64 300.19L353.5 301.17L353.53 300L356.07 296.72L358.32 292.91L360.08 285.29L360.99 286.27L364.1 290.75L369.91 296.06L377.04 299.4L388.44 303.28L393.14 307.01L397.95 315.48L398.22 316.44L399.22 310.48L399.32 302.74L398.74 297.29L398.95 291.71L397.99 286.52L395.35 280.54L390.43 274.57L384.02 270.16L376.85 267.66L369.7 267.05L361.79 269.24L356.2 274.01L352.11 274.23L347.11 276.01L343.63 280.26L341.68 287.69L342.33 295.5L343.14 298.25L340.26 302.74Z",
    fill: "#E24473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M340.26 302.74C334.81 309.6 336.45 312.92 336.48 319.02C336.51 325.11 332.9 326.99 332.9 326.99C326.95 329.37 320.43 323.96 320.43 323.96C320.43 323.96 321.47 338.52 340.52 336.44C340.52 336.44 355.94 334.93 358.32 323.9",
    stroke: "#AF3459",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M386.76 315.26C386.76 315.26 392.02 318.34 396.08 311.37C396.08 311.37 391.13 303.35 387.1 302.75V313.4L386.76 315.26Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M368.58 274.57C368.58 274.57 406.76 278.54 398.22 316.43C398.22 316.43 395.89 306 386.33 302.29",
    stroke: "#AF3459",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M353.59 315.26C347.78 317.08 342.06 307.35 344.44 302.01C346.82 296.68 353.49 301.17 353.49 301.17L353.19 312.86L353.59 315.25V315.26Z",
    fill: "#E8E4EC",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.35 277.94C357.35 277.94 361.54 293.79 374.71 298.46C374.71 298.46 386.29 302.36 387.09 302.75L387.17 312.66C387.17 312.66 386.33 327.55 370.78 327.56C355.23 327.56 353.16 313.52 353.16 313.52L353.52 300.01C353.52 300.01 357.64 295.08 358.3 292.92C358.96 290.76 360.21 284.59 360.21 284.59",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35 277.94C357.35 277.94 361.54 293.79 374.71 298.46C374.71 298.46 386.29 302.36 387.09 302.75L387.17 312.66C387.17 312.66 386.33 327.55 370.78 327.56C355.23 327.56 353.16 313.52 353.16 313.52L353.52 300.01C353.52 300.01 357.64 295.08 358.3 292.92C358.96 290.76 360.21 284.59 360.21 284.59",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M387.1 302.74C386.31 302.35 374.72 298.45 374.72 298.45C361.55 293.78 357.36 277.93 357.36 277.93",
    stroke: "#AF3459",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M371.24 298.84C371.24 298.84 374.86 309.05 373.57 311.38C373.57 311.38 370.25 312.29 367.97 311.55",
    stroke: "#620C90",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M353.53 300C353.53 300 357.65 295.07 358.31 292.91C358.97 290.75 360.22 284.58 360.22 284.58",
    stroke: "#AF3459",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M344.6 301.53C344.6 301.53 338.73 291.51 343.44 280.77C343.44 280.77 345.63 273.49 356.21 274.02C356.21 274.02 361.93 264.82 376.36 267.57C390.79 270.32 401.18 283.43 398.64 297.97",
    stroke: "#AF3459",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M342.56 297.87C342.56 297.87 338 299.64 340.14 305.6C340.14 305.6 341.86 309.58 344.78 309.81C344.78 309.81 342.56 304.56 344.44 302.01C344.44 302.01 342.42 298.85 342.56 297.87Z",
    fill: "#8E2B48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M645.81 38.0601V253.78H104.93V38.0601H645.81ZM647.81 36.0601H102.93V255.78H647.81V36.0601Z",
    fill: "#620C90"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 749.62,
    height: 465.22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep01);
export default __webpack_public_path__ + "static/media/step_01.6b84529c98ee54a66d9288ee40d605fb.svg";
export { ForwardRef as ReactComponent };